import React from "react";

import { css } from "@emotion/css";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { suffixId } from "@/uiKit/atoms/utils/ids.ts";

export type SelectTypeProps<T extends number | string | boolean> = {
  /** Id of the select; each option gets `${id}-option-${value}`. */
  id?: string;
  onSelectChange: (value: T) => void;
  options: {
    value: T;
    text: string;
  }[];
  selected: T;
};

export const SelectType = <T extends number | string | boolean>({
  id,
  onSelectChange,
  options,
  selected,
}: SelectTypeProps<T>): React.ReactElement => {
  const styles = useStyles(makeStyles);

  // add useOptimistic when avaialble, otherwise the settings will only change after the API call is made and refetched

  return (
    <div className={styles.container}>
      <Select id={id} variant="standard" value={selected} onChange={e => onSelectChange(e.target.value as T)}>
        {options.map(option => (
          <MenuItem
            id={suffixId(id, `option-${option.value.toString()}`)}
            key={option.value.toString()}
            value={option.value as string}
          >
            {option.text}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${theme.spacing(4)};
    .MuiInputBase-input {
      padding: ${theme.spacing(1.5, 2)};
      margin: 0;
      width: ${theme.spacing(96)};
    }
  `,
});
